import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

@Component({
  selector: 'app-basic-donut-chart',
  templateUrl: './basic-donut-chart.component.html',
  styleUrls: ['./basic-donut-chart.component.scss']
})
export class BasicDonutChartComponent implements OnInit {

  @Input() data = [];

  investmentZoneColor = {
    'USA': 'rgb(95,178,98)',
    'Eurozone': 'rgb(255,195,46)',
    'Japan': 'rgb(161,68,180)',
    'United Kingdom': 'rgb(62,156,243)',
  };

  chartOptions: {};
  Highcharts = Highcharts;

  constructor() { }

  ngOnInit(): void {
    this.data.forEach((d) => {
      d.color = this.investmentZoneColor[d.name]
    });
    this.chartOptions = {
      chart: {
        type: 'pie',
        backgroundColor: 'rgba(255,255,255,0)'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      navigation: {
        buttonOptions: {
          verticalAlign: 'bottom'
        }
      },
      plotOptions: {
        pie: {
          shadow: false,
          center: ['50%', '50%']
        }
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          return '<strong>' + this.point.name + '</strong>:'+
                 '<br> - Weight: ' + this.point.y.toFixed(2) + '%'
        },
        style: {
          color: 'rgb(118,168,255)',
        }
      },
      series: [{
        name: 'Investment Zone',
        data: this.data,
        size: '70%',
        innerSize: '60%',
        dataLabels: {
          formatter: function () {
            return this.y > 5 ? this.point.name : null;
          },
          color: 'grey',
          style: {
            textOutline: 0
          },
          distance: 10
        }
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 400
          },
          chartOptions: {
            series: [{
            }, {
              id: 'versions',
              dataLabels: {
                enabled: false
              }
            }]
          }
        }]
      }
    };

    HC_exporting(Highcharts);

    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);
  }

}
